import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = { class: "p-2 font-bold text-xs rounded-[6px] bg-primary-400 text-primary-600 leading-[18px]" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 text-[0.625rem]" }, "Primary Diagnosis", -1)
const _hoisted_5 = { class: "mt-1 text-sm font-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 text-[0.625rem]" }, "Comorbid", -1)
const _hoisted_7 = { class: "flex flex-wrap items-center" }
const _hoisted_8 = {
  key: 0,
  class: "px-2 py-1 mt-1 mr-1 text-xs italic bg-neutral-200 text-neutral-600 rounded-2xl"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 text-[0.625rem]" }, "Perpetrator", -1)
const _hoisted_10 = { class: "flex flex-wrap items-center" }

import { PropType, ref } from "vue";
import DateDetail from "@/components/partials/DateDetail.vue";
import { useRouter } from "vue-router";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import http from "@/axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'CaseCard',
  props: {
	routeLink: {
		type: String,
		default: "#",
	},
	routeDeleteLink: {
		type: String,
		default: "#",
	},
	caseNumber: {
		type: String,
		default: null,
	},
	primaryDiagnosis: {
		type: String,
		default: null,
	},
	comorbidList: {
		type: Array as PropType<string[]>,
		default: () => [],
	},
	perpetratorList: {
		type: Array as PropType<string[]>,
		default: () => [],
	},
	date: {
		type: String,
		default: null,
	},
},
  setup(__props) {

const router = useRouter();
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const selectedId = ref(null);
const props = __props;

const showDeleteModal = (item: any): void => {
	showConfirmation.value = true;
	selectedId.value = item;
};

const deleteRecord = async () => {
	await http
		.delete(props.routeDeleteLink)
		.then(() => {
			showSuccess.value = true;
			showConfirmation.value = false;
			window.location.reload();
		})
		.catch((error) => console.log(error));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).replace(__props.routeLink))),
      class: "flex flex-col lg:p-6 p-4 space-y-2 border border-gray-200 cursor-pointer rounded-2xl"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.caseNumber || "Offline(No Case Number)"), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(DateDetail, { date: __props.date }, null, 8, ["date"]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(DeleteButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeleteModal(__props.caseNumber))),
              class: "shrink-0"
            })
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.primaryDiagnosis), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comorbidList, (list) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: list }, [
              list
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(list), 1))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.perpetratorList, (list) => {
            return (_openBlock(), _createElementBlock("span", {
              key: list,
              class: "px-2 py-1 mt-1 mr-1 text-xs italic bg-neutral-200 text-neutral-600 rounded-2xl"
            }, _toDisplayString(list), 1))
          }), 128))
        ])
      ])
    ]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (deleteRecord())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Delete Record",
      content: "Are you sure you wish to delete this Case?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = false)),
      "action-text": "Close",
      title: "Record Deleted!",
      content: "Selected Case has been successfully deleted!"
    }, null, 8, ["show"])
  ], 64))
}
}

})